/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Group_OnlineInputs */

const en_service_type_group_online = /** @type {(inputs: Service_Type_Group_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online`)
};

const pl_service_type_group_online = /** @type {(inputs: Service_Type_Group_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online`)
};

/**
* | output |
* | --- |
* | "Online" |
*
* @param {Service_Type_Group_OnlineInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_group_online = /** @type {((inputs?: Service_Type_Group_OnlineInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Group_OnlineInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_group_online(inputs)
	return en_service_type_group_online(inputs)
});